import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninFieldCompleted = (
  track: RedcatAnalyticsStore['track'],
  { fieldName, fieldIndex }: { fieldName: string; fieldIndex: number },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.FieldCompleted,
    properties: {
      field_name: fieldName,
      field_index: fieldIndex,
    },
  };

  track(event);
};
